import { useOnboardingSteps, useSubscriptionDetails } from '@features/user';
import { useUserName } from '@features/user/store/hooks';
import { Box, Typography } from '@mui/material';

import { ReferralInviteBanner } from './ReferralInviteBanner';
import { TrialBanner } from './TrialBanner';

/**
 * Renders the appropriate header banner based on subscription status:
 * - Trialing: TrialBanner
 * - Active: ReferralInviteBanner
 * - Otherwise (past_due, paused, canceled, none): Nothing
 */
const HeaderBanner = () => {
  const { data: subscriptionDetails } = useSubscriptionDetails();
  const status = subscriptionDetails?.status;

  if (status === 'trialing') {
    return <TrialBanner />;
  }

  if (status === 'active') {
    return <ReferralInviteBanner />;
  }

  // For past_due, paused, canceled, or no subscription - show nothing
  // (Future: add subscription update button for past_due/paused/canceled)
  return null;
};

export const Header = () => {
  const name = useUserName();
  const onboardingSteps = useOnboardingSteps();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 3,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: 500, pb: 0 }}>
        {name &&
          (!onboardingSteps?.generated_first_note
            ? `Welcome, ${name}!`
            : `Welcome back, ${name}!`)}
      </Typography>
      <HeaderBanner />
    </Box>
  );
};